import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Autocomplete from './Autocomplete';

const UserSelect = ({ user, userList, onChange, disabled, value }) => {
  return (
    <div>
      {/* Desktop */}
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Autocomplete
          size="small"
          onChange={(event, value) => onChange(value)}
          value={user ? user : value}
          options={[...userList].sort((a, b) => a.lastName.localeCompare(b.lastName))}
          getOptionLabel={(option) => `${option?.firstName} ${option?.lastName}`}
          groupBy={(option) => option.lastName[0].toUpperCase()}
          disabled={disabled}
        />
      </Box>

      {/* Mobile */}
      <Box sx={{ display: { sm: 'none' } }}>
        <Select
          id="user-select"
          size="small"
          className="user-select"
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        >
          {userList.map((item) => (
            <MenuItem key={item.uid} value={item}>
              {item.firstName} {item.lastName}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </div>
  );
};

UserSelect.propTypes = {
  user: PropTypes.object,
  userList: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default memo(UserSelect);
